//  Copyright (c) 2019 First Foundry Inc. All rights reserved.

import { stackReducer } from 'redux-foundry'
import {
  ModalStackTypes,
} from './actionTypes'

export default stackReducer([], ModalStackTypes)
